export const APPLICATION_NAME = "ACTIONPARKMEDIA";
export const APPLICATION_NAME_NORMAL = "Action Park Media";
export const APP_VERSION = "2.0.0";

export const LOCAL_STORAGE_ACCESS_TOKEN = `${APPLICATION_NAME}_ACCESS_TOKEN`;
export const LOCAL_STORAGE_REFRESH_TOKEN = `${APPLICATION_NAME}_REFRESH_TOKEN`;

export const LOCAL_STORAGE_PHONE_COUNTRY = `${APPLICATION_NAME}_PHONE_COUNTRY`;
export const LOCAL_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;
export const SESSION_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;

export const googlePlacesKey = "AIzaSyCR388mWBleCqk4xOU2ZBjoBM_Aiu6VNt4";

export const SPLASH_SCREEN_DURATION_IN_MILLISECONDS = 400;

export const LOGOUT = "logout";

export const keyboardTypeEnum = {
  default: "default",
  email: "email-address",
  numeric: "number-pad",
  decimal: "decimal-pad",
  phone: "phone-pad",
};

// constants/routes.js
export const ROLES = {
  USER: "user",
  ADMIN: "admin",
  SUPER_ADMIN: "superAdmin",
};

export const ROUTES = {
  // Public
  HOME: "/",
  LOGIN: "/prijava",
  REGISTER: "/registracija",

  // Auth
  EMAIL_VERIFICATION: "/verifikacija-email",
  EMAIL_VERIFICATION_NOTICE: "/verifikacija-potrebna",
  FORGOT_PASSWORD: "/zaboravljena-lozinka",
  RESET_PASSWORD: "/promena-lozinke",

  // User Dashboard
  USER_WORKSHOPS: "/korisnicki-panel/moji-setovi",
  USER_SETTINGS: "/korisnicki-panel/podesavanja",

  // Admin Dashboard
  ADMIN_OVERVIEW: "/admin-panel/pregled",
  ADMIN_USERS: "/admin-panel/korisnici",
  ADMIN_ORDERS: "/admin-panel/porudzbine",
  ADMIN_SETS: "/admin-panel/setovi",
};

export const ACCESS = {
  PUBLIC: "public", // Neulogovani samo (login, register)
  AUTHENTICATED: "authenticated", // Bilo ko ulogovan
  VERIFIED: "verified", // Ulogovan + email verified
  USER_ONLY: "userOnly", // Samo obični korisnici (verified)
  ADMIN: "admin", // Admin ili superAdmin
  SUPER_ADMIN: "superAdmin", // Samo superAdmin
};

export const CONTACT_TOPICS = [
  { value: "individualne-konsultacije", label: "Individualne konsultacije" },
  { value: "radionice", label: "Radionice za decu" },
  { value: "edukacije", label: "Edukacije" },
  { value: "metod-45", label: "Metod 45" },
  { value: "saradnja", label: "Saradnja i partnerstvo" },
  { value: "ostalo", label: "Ostalo" },
];

export const TEAM_DATA = [
  {
    id: 1,
    name: "Olgica Pušić Ugrnov",
    role: "Diplomirani pedagog, mama dvoje dece",
    shortBio:
      "Više od dve decenije profesionalnog rada posvetila je vaspitno-obrazovnom procesu, razvoju dece i podršci roditeljima. Autor je programa 'Recepti za roditeljstvo' i 'Metod 45'.",
    fullDescription: [
      "Više od dve decenije profesionalnog rada posvetila je vaspitno-obrazovnom procesu, razvoju dece i podršci roditeljima i stručnjacima u sistemu predškolskog vaspitanja i obrazovanja. Polje njenog interesovanja vezano je za rani razvoj dece, stvaralaštvo, kao i za osmišljavanje podsticajnog okruženja u kome deca mogu slobodno da istražuju, rastu i razvijaju svoje potencijale. ",
      "Profesionalnu karijeru započela je kao stručni saradnik – pedagog u PU 'Radosno detinjstvo' u Novom Sadu, nakon čega je svoje iskustvo produbila u PU 'Dobra Vila', gde od 2016. godine obavlja funkciju direktora. ",
      "Od 2003. godine vodi kreativnu radionicu 'Kobajagi', program namenjen deci uzrasta od 3 do 10 godina koji razvija maštu, samopouzdanje i stvaralačko mišljenje kroz igru, muziku i istraživanje. ",
      "Poseban segment njenog rada čini podrška roditeljima kroz predavanja, radionice i individualne konsultacije. ",
      "Kao autor, realizator i izlagač aktivno učestvuje u stručnim skupovima, akreditovanim seminarima i naučnim konferencijama u zemlji i regionu. Posebno je posvećena temama koje se tiču dečje igre i pružanju podrške roditeljima kroz praktična predavanja i programe.",
    ],
    professionalFocus: [
      "Razvoj i primena savremenih pedagoških pristupa",
      "Osmišljavanje didaktičkih materijala kao sredstava za razvoj i učenje",
      "Muzičke aktivnosti kao podsticaj celokupnom razvoju deteta",
      "Jačanje kompetencija vaspitača i stručnih saradnika u radu sa decom predškolskog uzrasta",
      "Partnerstvo sa porodicom i podrška roditeljstvu",
    ],
    quote:
      "Verujem da se kvalitetno detinjstvo gradi kroz odnos – toplinu, razumevanje, podršku i profesionalno vođenje. Moja misija je da svojim radom podstaknem i dete i odraslog da uče, istražuju, rastu i uživaju u procesu sticanja znanja. Zato u centar svakog programa postavljam dete, njegovu radost otkrivanja i moć stvaralaštva",
    image: "/uploads/olja.webp",
  },
  {
    id: 2,
    name: "Nikolina Ilić",
    role: "Vaspitač dece uzrasta do tri godine, mama četvoro dece",
    shortBio:
      "Iza nje je više od 16 godina posvećenog rada u oblasti ranog razvoja i podrške porodicama. 2008. godine je osnovala Predškolsku ustanovu 'Dobra vila'. Koautor programa 'Recepti za roditeljstvo' i 'Metod 45'.",
    fullDescription: [
      "Iza nje je više od 16 godina posvećenog rada u oblasti ranog razvoja i podrške porodicama. 2008. godine je osnovala Predškolsku ustanovu 'Dobra vila', jednu od prvih privatnih predškolskih ustanova u Novom Sadu. U ustanovi je zaposlena kao vaspitač dece. ",
      "U svom radu neguje atmosferu poverenja i slobode, verujući da deca najbolje uče kroz igru, pokret i istraživanje sveta oko sebe. Njen profesionalni fokus usmeren je na rani razvoj i kreiranje prostora koji podstiče dete da samostalno otkriva, isprobava i razvija svoje sposobnosti. ",
      "Pored rada sa decom, pruža podršku roditeljima kroz razgovore, savetovanje, radionice i praktične preporuke za svakodnevne situacije u porodici.",
    ],
    professionalFocus: [
      "Rani razvoj dece i podrška adaptaciji u prvoj i drugoj godini života",
      "Osmišljavanje bezbednog i stimulativnog okruženja za decu do 3 godine",
      "Igra kao osnov za učenje, razvoj emocija i komunikacije",
      "Saradnja sa porodicom i praktična podrška roditeljima u ranom detinjstvu",
      "Kreiranje jednostavnih materijala za igru i istraživanje",
    ],
    quote:
      "Verujem da se kvalitetno detinjstvo gradi kroz razumevanje i podršku. Moja misija je da svakom detetu omogućim da slobodno otkriva svet, a svakom roditelju da dobije podršku koja mu je potrebna. Dete, njegova radost i radoznalost uvek su u centru mog rada.",
    image: "/uploads/nina.webp",
  },
];

export const WORKSHOP_DATA = [
  {
    SKU: "RECEPT-ZA-ODVIKAVANJE-OD-PELENA",
    title: "Recept za odvikavanje od pelena",
    badge: "najpopularnija - 1300+ roditelja",
    description:
      "Polaznici dobijaju konkretne, jednostavne i odmah primenjive korake koje treba da preduzmu kako bi odvikli dete od pelena.",
    price: 2000,
  },
  {
    SKU: "RECEPT-KAKO-DA-NECU-POSTANE-HOCU",
    title: "Recept kako da neću postane hoću",
    badge: null,
    description:
      "Polaznici dobijaju odmah primenjiv recept kako da reaguju na negodovanje i detetove burne reakcije.",
    price: 2000,
  },
  {
    SKU: "RRECEPT-ZA-DOBRU-IGRACKU",
    title: "Recept za dobru igračku",
    badge: null,
    description:
      "Kroz analizu konkretnih igračaka polaznici uče da odaberu kvalitetnu, stimulativnu igračku za dete.",
    price: 2000,
  },
  {
    SKU: "RECEPT-KAKO-SE-OD-KNJIGE-I-UZ-KNJIGU-RASTE",
    title: "Recept kako se od knjige i uz knjigu raste",
    badge: null,
    description:
      "Polaznici otkrivaju da knjiga nije samo predmet za čitanje i dobijaju ideje kako svaku knjigu mogu da upotrebe kao moćno sredstvo za sve aspekte dečijeg razvoja.",
    price: 2000,
  },
  {
    SKU: "RECEPT-ZA-RAZGOVOR-KAO-NAJVREDNIJI-POKLON",
    title: "Recept za razgovor kao najvredniji poklon",
    badge: null,
    description:
      "Polaznici uče kako da prepoznaju kada je vreme za razgovor, kako da vode razgovor i zašto je on značajan za dečiji razvoj.",
    price: 2000,
  },
  {
    SKU: "INDIVIDUALNA-KONSULTACIJA",
    title: "Individualne konsultacije",
    badge: "1 na 1 savetovanje",
    description:
      "Ako osećate da vam je potrebna personalizovana podrška u vaspitanju deteta ili vam je nezgodno da se uklopite u termine radionica i predavanja, individualne konsultacije su namenjene upravo Vama.",
    extendDescription:
      "Možemo ih realizovati u našem prostoru u Novom Sadu ili onlajn. Na ovaj način dobijate potpuno individualizovan pristup. Zajedno radimo na Vašim konkretnim izazovima u roditeljstvu, u skladu sa Vašim stilom vaspitanja i specifičnim potrebama Vašeg deteta. Tokom konsultacija, dobićete jasne i praktične savete koje možete odmah primeniti.",
    price: 3500,
  },
];
